function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaIconsArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.825,
    height: 7.412,
    viewBox: "0 0 11.825 7.412",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m6 9 4.5 5L15 9",
    transform: "translate(-4.588 -7.588)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    "data-name": "Icons/arrow"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaIconsArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FA_icons_arrow_down.8b7727162c03b78704a384c9c7d94f82.svg";